import { IItemData } from '@/models';
import {
  IItemPaginatedListData,
  IItemService,
  ItemUploadResponseData,
  UPLOAD_ITEM_FILE_TIMEOUT_IN_MS
} from './item.types';
import { AxiosInstance } from 'axios';
import { objectToFormData } from '@/utils/objectToFormData';

export class ItemService implements IItemService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/csi/items/';
  }

  exportItems(): Promise<any> {
    return this.axios
      .get<IItemData>(`${this.endpoint}export/`, {
        responseType: 'blob',
        timeout: 60 * 1000 * 10 //10 mins
      })
      .then(({ data }) => data);
  }

  fetchItems(
    page: number,
    search?: string,
    snapshot?: number
  ): Promise<IItemPaginatedListData> {
    return this.axios
      .get<IItemPaginatedListData>(`${this.endpoint}`, {
        params: { page, search, pricing: snapshot }
      })
      .then(({ data }) => data);
  }

  fetchItem(item: string): Promise<IItemData> {
    return this.axios
      .get<IItemData>(`${this.endpoint}${item}/`)
      .then(({ data }) => data);
  }

  createItem(data: IItemData): Promise<IItemData> {
    return this.axios
      .post<IItemData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateItem(data: IItemData): Promise<IItemData> {
    return this.axios
      .patch<IItemData>(`${this.endpoint}${data.item}/`, data)
      .then(({ data }) => data);
  }

  deleteItem(item: string): Promise<any> {
    return this.axios.delete(`${this.endpoint}${item}/`);
  }

  uploadItemFile(file: File): Promise<ItemUploadResponseData> {
    const formData = objectToFormData({ file_upload: file });
    return this.axios
      .post(`${this.endpoint}upload_file/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: UPLOAD_ITEM_FILE_TIMEOUT_IN_MS
      })
      .then(({ data }) => data);
  }
}
